import { useContext } from 'react'
import { useFormState } from 'react-hook-form'
import { Dropdown, EditorInput, TextInput } from '~/components/Form'
import type { InputInFormProps } from '~/components/Form/Input/input'
import { ToggleInput } from '~/components/Form/Input/ToggleInput'
import { EmailTemplateSelector } from '~/components/Scopes/Actions/Components/EmailTemplateSelector'
import type { MeetingFormValues } from '~/domains/actions/forms/meetingSchema'
import { AsideActionContext } from '~/utils/contextes'
import { subjectField, subjectLine } from './MeetingInvitationFields.css'

const alertOptions = [
  { label: 'Le jour même', value: '0' },
  { label: '1 jour avant', value: '1' },
  { label: '2 jours avant', value: '2' },
  { label: '3 jours avant', value: '3' },
  { label: '4 jours avant', value: '4' },
  { label: '5 jours avant', value: '5' },
  { label: '10 jours avant', value: '10' }
]

type MeetingInvitationFieldsProps = InputInFormProps & {
  name: string
  placeholderCategories: string[]
}

export const MeetingInvitationFields = ({
  placeholderCategories,
  register,
  watch,
  setValue,
  control
}: MeetingInvitationFieldsProps) => {
  if (!register || !watch || !setValue || !control) {
    throw new Error('MeetingInvitationFields must be used inside a Form')
  }
  const { errors } = useFormState<MeetingFormValues>({ control })
  const { setIsDirty } = useContext(AsideActionContext)
  const sendInvitation = watch('sendInvitation')

  return (
    <>
      <ToggleInput
        name="sendInvitation"
        label="Envoyer un email d'invitation"
        register={register}
        setValue={setValue}
        watch={watch}
        onChange={() => setIsDirty(true)}
      />
      {sendInvitation && (
        <>
          <div className={subjectLine}>
            <div className={subjectField}>
              <TextInput
                name="invitationSubject"
                label="Sujet de l'email"
                required
                register={register}
                control={control}
                setValue={setValue}
                watch={watch}
                error={errors.invitationSubject}
              />
            </div>
            <EmailTemplateSelector
              compact
              name="invitationTemplateId"
              subjectFieldName="invitationSubject"
              contentFieldName="invitationContent"
              register={register}
              setValue={setValue}
              watch={watch}
              onChange={() => setIsDirty(true)}
            />
          </div>
          <EditorInput
            name="invitationContent"
            rows={5}
            autofocus={false}
            required
            placeholderCategories={placeholderCategories}
            register={register}
            control={control}
            setValue={setValue}
            watch={watch}
            error={errors.invitationContent}
          />
          <Dropdown
            name="alertDaysBefore"
            label="Rappel dans l'invitation"
            options={alertOptions}
            emptyLabel="Aucun rappel"
            defaultValue=""
            register={register}
            control={control}
            setValue={setValue}
            watch={watch}
            onChange={() => setIsDirty(true)}
          />
        </>
      )}
    </>
  )
}
